<template lang="pug">
    //- TODO: different actions
    //- 1. completely new user - form
    //-    - gender
    //-    - first name
    //-    - last name
    //-    - password
    //- 2. existing user - redirect / error
    //-    - signin (if not logged in)
    //-    - dashboard (otherwise)
    //- 3. invalid token
    //-    - error output

    el-container.has-centered-content(v-loading="! initialized")
        .error(v-if="error")
            template(v-if="error.code")
                Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
            template(v-else)
                Error(:message="$t('Something went wrong!')" :code="501")
        .panel-container(v-else-if="initialized")
            .logo
                progressive-img(:src="require('@/assets/CObyVA.svg')")

            .greeting.text-center(v-if="name")
                h2 {{ $t('Hello {name}', { name }) }}
                p {{ $t('welcome to the team of {initiator}', { initiator }) }}

            el-form.panel-form(
                ref="form"
                :model="form"
                :rules="rules"
                label-position="top"
                @submit.native.prevent="submit"
            )
                .card.z-depth-2(v-loading="loading")
                    .alert.primary
                        p {{ $t('Please review your account data') }}
                    el-row.no-padding(:gutter="20")
                        el-col(:lg="6" :md="6")
                            el-form-item(:label="$t('Salutation')" prop="gender")
                                el-select.is-full-width(placeholder="" v-model="form.gender")
                                    el-option(:label="$t('Mr.')" value="M")
                                    el-option(:label="$t('Mrs.')" value="F")
                                    el-option(:label="$t('Undefined')" value="X")
                        el-col(:lg="9" :md="9")
                            el-form-item(:label="$t('First name')" prop="first_name")
                                el-input(v-model="form.first_name")
                        el-col(:lg="9" :md="9")
                            el-form-item(:label="$t('Last name')" prop="last_name")
                                el-input(v-model="form.last_name")
                    .alert.primary
                        p {{ $t('Define a password') }}
                    el-form-item(prop="password" :label="$t('Password')" size="large")
                        el-input(
                            type="password"
                            v-model="form.password"
                            suffix-icon="el-icon-fa-key fas"
                            ref="password"
                        )
                el-form-item.buttons
                    //- el-button.password-reset-button(
                    //-     type="info"
                    //-     size="large"
                    //-     :disabled="loading"
                    //-     @click="$router.push('/')"
                    //- )
                    //-     | {{ $t('Dismiss') }}
                    el-button.submit-button(
                        type="primary"
                        size="large"
                        :disabled="loading"
                        @click.native="submit"
                    )
                        | {{ $t('Save the account data and login') }}


            //- el-form.panel-form.el-form--label-left(
            //-     ref="form"
            //-     :model="form"
            //-     :rules="rules"
            //-     @submit.native.prevent="submit"
            //- )
            //-     .card.z-depth-2(v-loading="loading")
            //-         .title-container
            //-             h3 {{ $t('Reset password') }}
            //-         el-form-item(prop="password" :label="$t('New password')" size="large")
            //-             el-input(
            //-                 type="password"
            //-                 v-model="form.password"
            //-                 suffix-icon="el-icon-fa-key fas"
            //-                 ref="password"
            //-             )
            //-     el-form-item.buttons
            //-         el-button.password-reset-button(
            //-             type="info"
            //-             size="large"
            //-             :disabled="loading"
            //-             @click="$router.push('/')"
            //-         )
            //-             | {{ $t('Dismiss') }}
            //-         el-button.submit-button(
            //-             type="primary"
            //-             size="large"
            //-             :disabled="loading"
            //-             @click.native="submit"
            //-         )
            //-             | {{ $t('Save the new password and login') }}
</template>

<i18n>
{
    "de": {
        "Oops, an error occurred!": "Es ist ein Fehler aufgetreten!",
        "Hello {name}, welcome to the team of {initiator}": "Hallo {name}, willkommen im Team von {initiator}",
        "Hello {name}": "Hallo {name}",
        "welcome to the team of {initiator}": "willkommen im Team von {initiator}",
        "Please review your account data and define a password": "Bitte kontrolliere deine Account-Daten und lege ein Passwort fest",
        "Please review your account data": "Bitte kontrolliere deine Account-Daten",
        "Define a password": "Lege ein Passwort fest",
        "New password": "Neues Passwort",
        "Salutation": "Anrede",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Email": "E-Mail",
        "Mr.": "Herr",
        "Mrs.": "Frau",
        "Undefined": "Unbekannt",
        "Cancel": "Abbrechen",
        "Save the account data and login": "Account-Daten speichern und einloggen"
    }
}
</i18n>

<script>

import _ from 'lodash'
import { mapMutations, mapActions, mapGetters } from 'vuex'

import store from '@/store'
import router from '@/router'

import Error from '@/components/Error';

export default {
    name: 'AcceptTeamInvitation',
    data() {
        let data = {
            loading: false,
            initialized: false,
            error: false,
            form: {
                email: '',
                password: '',
                first_name: '',
                last_name: '',
                gender: '',
            },
            initiator: '',
            rules: {
                email: 'required|email',
                password: 'required|min:6',
                first_name: 'required',
                last_name: 'required',
                gender: 'required',
            },
        };

        return data;
    },
    components: {
        Error,
    },
    computed: {
        name() {
            // TODO
            return `${this.form.first_name} ${this.form.last_name}`.trim();
        },
        token() {
            return this.$route.params.token
        },
    },
    methods: {
        submit() {
            this.$refs.form.validate((valid, errors) => {
                if (valid) {
                    this.loading = true
                    this.accept(this.form)
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },

        accept(user) {
            this.acceptInvitation({ teamMember: user, token: this.token })
                .then(user => {
                    // add user.auth_token to state
                    const token = user.auth_token;
                    delete user.auth_token;
                    if (token) {
                        this.addTokenToState({ token, name: 'token' });
                        this.addAuthenticatedUserToState(user);
                        this.fetchSetup()
                            .then(() => {
                                this.$notify.success({
                                    title: this.$t('Hello {name}', { name: this.name }),
                                    message: this.$t('welcome to the team of {initiator}', { initiator: this.initiator }),
                                    iconClass: 'fas el-icon-fa-check',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000,
                                })
                                router.push({ name: 'dashboard' })
                            })
                            .catch(this.handleResponseError)
                    } else if (this.user) {
                        this.$notify.success({
                            title: this.$t('Hello {name}', { name: this.name }),
                            message: this.$t('welcome to the team of {initiator}', { initiator: this.initiator }),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                        router.push({ name: 'dashboard' })
                    } else {
                        this.error = true
                        this.loading = false
                        this.initialized = true
                    }
                })
                .catch(err => {
                    this.loading = false
                    this.initialized = true
                    this.handleResponseError(err)
                })
        },

        handleResponseError(err) {
            const { graphQLErrors } = err

            let code = 501;
            let message = 'An error occurred!';

            if (graphQLErrors) {
                code = _.get(graphQLErrors, '0.code') || code;
                message = _.get(graphQLErrors, '0.message') || message;
            }

            switch (code) {
                case 401:
                    this.error = { code, message: 'You are not authorized' };
                    break;
                case 403:
                    this.error = { code, message: 'You are not allowed to be here' };
                    break;
                default:
                    this.error = true;
                    break;
            }

            this.loading = false
            this.initialized = true

            /* eslint no-console: ["error", { allow: ["error"] }] */
            console.error(err);
        },

        ...mapActions({
            validateInvitation: 'teamMember/validateInvitation',
            acceptInvitation: 'teamMember/acceptInvitation',
            fetchSetup: 'fetchSetup',
        }),
        ...mapMutations({
            user: 'auth/user',
            addTokenToState: 'auth/addTokenToState',
            addAuthenticatedUserToState: 'auth/addAuthenticatedUserToState',
        })
    },
    // beforeRouteEnter (to, from, next) {
    //     // const auth = _.get(store, 'state.auth')
    //     // if (auth.token) next('/dashboard')
    //     // else next()
    // },
    mounted() {
        this.validateInvitation(this.token)
            .then(user => {
                this.form.email = user.email
                this.form.first_name = user.first_name
                this.form.last_name = user.last_name
                this.form.gender = user.gender

                this.initiator = user.initiatorName

                if (user.email_verified_at !== null) {
                    // accept invitation + redirect to dashboard
                    this.accept(user)
                } else {
                    this.initialized = true
                }
            })
            .catch(this.handleResponseError)
    }
}
</script>

<style lang="sass" scoped>
    .el-container::v-deep .el-loading-mask
        background-color: rgba(242,244,248, 0.7)
    .text-center
        text-align: center
    .greeting
        h2
            margin-bottom: 0.5rem
    .panel-form
        margin-top: 2rem
</style>
